import React from 'react'
import OnfsButton from './OnfsButton'
import { useReactToPrint } from 'react-to-print'

export default function OnfsPrintBtn({ label, printId }) {
  const handlePrint = useReactToPrint({
    content: () => printId.current
  })

  return <OnfsButton label={label} onClick={handlePrint} link />
}
